import React from 'react';
import KopaLogo from '../../assets/kopa-logo.svg';
import Correct from '../../assets/correct.svg';
import { Container, MessageCointaine, LinkButton } from './styles';

export default function SuccessRecover() {
    return (
        <Container>
            <img
                src={KopaLogo}
                alt="KopaLogo"
                className="logo"
            />
            <MessageCointaine>
                <img
                    className="correct-image"
                    src={Correct}
                    alt="KopaLogo"
                />
                <h1 className="alert-title">SUCESSO!</h1>
                <h3 className="alert-subtitle">Senha redefinida com sucesso</h3>
                <LinkButton to="/">
                    <button
                        type="submit"
                    > LOGIN
                    </button>
                </LinkButton>
            </MessageCointaine>

        </Container>

    );
}
